module.exports = __webpack_public_path__ + "static/media/yield-improvement.60b6abd2.svg";